(function () {
  'use strict';

  var CONSENT_TEXT = 'I agree to receive email marketing and understand I can unsubscribe at any time.';
  var GAME_META = {
    wheel: {
      title: 'Spin-A-Sale Wheel',
      subtitle: 'Spin the wheel for instant savings',
      stageLabel: 'The wheel is revealing your reward.'
    },
    scratch: {
      title: 'Scratch To Reveal',
      subtitle: 'Scratch to uncover your prize',
      stageLabel: 'Scratch away 65% of the gold foil.'
    },
    mystery_box: {
      title: 'Mystery Box',
      subtitle: 'Open the box for a surprise',
      stageLabel: 'The box is opening your reward.'
    }
  };

  var ICONS = {
    wheel: '<svg viewBox="0 0 100 100" aria-hidden="true"><circle cx="50" cy="50" r="45" fill="#0c1610" stroke="#d4a850" stroke-width="2"/><path d="M50 50 95 50A45 45 0 0 1 50 95Z" fill="#7a1a1f"/><path d="M50 50 50 95A45 45 0 0 1 5 50Z" fill="#132016"/><path d="M50 50 5 50A45 45 0 0 1 50 5Z" fill="#7a1a1f"/><path d="M50 50 50 5A45 45 0 0 1 95 50Z" fill="#132016"/><circle cx="50" cy="50" r="13" fill="#d4a850"/></svg>',
    scratch: '<svg viewBox="0 0 100 100" aria-hidden="true"><rect x="14" y="24" width="72" height="52" rx="5" fill="#0c1610" stroke="#d4a850"/><path d="M20 30h60v40H20z" fill="#d4a850"/><path d="M24 34h24l-8 32H24z" fill="#132016"/><path d="M58 35q-8 9 2 16t-2 16" fill="none" stroke="#fff4d2" stroke-width="3" opacity=".65"/></svg>',
    mystery_box: '<svg viewBox="0 0 100 100" aria-hidden="true"><path d="M18 48h64v38H18z" fill="#7a1a1f" stroke="#d4a850"/><path d="M46 48h8v38h-8z" fill="#d4a850"/><path d="M14 33h72v17H14z" fill="#a02530" stroke="#d4a850"/><path d="M46 33h8v17h-8z" fill="#d4a850"/><path d="M39 33q11-18 22 0" fill="none" stroke="#d4a850" stroke-width="4"/></svg>'
  };

  // ── Resilient fallbacks ──────────────────────────────────────────────
  // If the Shopify section settings get wiped/reset, the game must still
  // work. These defaults guarantee a working claim endpoint + prize pool.
  var DEFAULT_CLAIM_ENDPOINT = 'https://a.klaviyo.com/client/subscriptions/?company_id=RVqrQR&list_id=W5ffbq';
  var DEFAULT_PRIZES = [
    { id: 'p10',   name: '10% Off',                      shortLabel: '10%',  type: 'percentage',    discount_code: 'SAVE10',    odds: 48, grand: false, active: true },
    { id: 'p15',   name: '15% Off',                      shortLabel: '15%',  type: 'percentage',    discount_code: 'SAVE15',    odds: 20, grand: false, active: true },
    { id: 'pship', name: 'Free Shipping',                shortLabel: 'SHIP', type: 'free_shipping', discount_code: 'FREESHIP',  odds: 14, grand: false, active: true },
    { id: 'pgift', name: 'Free Canna Buust w/ Purchase', shortLabel: 'GIFT', type: 'free_gift',     discount_code: 'FREECANNA', odds: 10, grand: false, active: true },
    { id: 'p20',   name: '20% Off',                      shortLabel: '20%',  type: 'percentage',    discount_code: 'SAVE20',    odds: 8,  grand: false, active: true }
  ];

  document.querySelectorAll('[data-pyp]').forEach(init);

  function init(root) {
    if (root.dataset.ready) return;
    root.dataset.ready = '1';

    var config = readConfig(root);
    if (!config) return;
    if (config.backgroundImage) root.style.setProperty('--pyp-bg-image', 'url("' + config.backgroundImage + '")');

    var state = {
      phase: 'closed',
      config: config,
      lead: null,
      selectedGame: null,
      selectedPrize: null,
      opened: false,
      lastFocus: null,
      sessionId: getSessionId(config),
      countdownTimer: null
    };

    enhanceHeader(root, config);
    renderGames(root, state);
    bind(root, state);
    track(config, 'pyp_impression', baseEvent(state));
    scheduleTrigger(root, state);
  }

  function readConfig(root) {
    try {
      var config = JSON.parse(root.getAttribute('data-config') || '{}');
      config.campaignName = config.campaignName || 'Pick Your Prize';
      config.campaignId = config.campaignId || slug(config.campaignName);
      // Fall back to a working Klaviyo endpoint if the section setting is blank.
      config.claimEndpoint = config.claimEndpoint || DEFAULT_CLAIM_ENDPOINT;
      // Build the active prize pool; if the section has no prizes, use defaults
      // so the game can always award something.
      var rawPrizes = (config.prizes || []).filter(function (prize) {
        return prize && prize.active !== false;
      });
      if (!rawPrizes.length) rawPrizes = DEFAULT_PRIZES;
      config.prizes = rawPrizes.map(normalizePrize);
      return config;
    } catch (err) {
      console.error('[Pick Your Prize] Invalid config', err);
      // Last-resort config so the game still works even if data-config is broken.
      return {
        campaignName: 'Pick Your Prize',
        campaignId: 'pick-your-prize',
        claimEndpoint: DEFAULT_CLAIM_ENDPOINT,
        prizes: DEFAULT_PRIZES.map(normalizePrize),
        gameOrder: 'wheel,scratch,mystery_box',
        defaultGame: 'wheel',
        triggerType: 'delay',
        delaySeconds: 5,
        pageRule: 'all',
        redirectPath: '/'
      };
    }
  }

  function enhanceHeader(root, config) {
    var header = root.querySelector('.pyp-header');
    if (!header || header.dataset.enhanced) return;
    header.dataset.enhanced = '1';

    var logo = header.querySelector('.pyp-logo');
    if (!logo && config.logoUrl) {
      logo = document.createElement('img');
      logo.className = 'pyp-logo';
      logo.src = config.logoUrl;
      logo.alt = '';
      logo.loading = 'lazy';
      logo.onerror = function () { logo.style.display = 'none'; };
    }

    var row = document.createElement('div');
    row.className = 'pyp-logo-row';
    row.innerHTML = '<span class="pyp-laurel" aria-hidden="true"></span>';
    if (logo) row.appendChild(logo);
    row.insertAdjacentHTML('beforeend', '<span class="pyp-laurel pyp-laurel--right" aria-hidden="true"></span>');
    header.insertBefore(row, header.firstChild);

    var title = header.querySelector('h2');
    var subtitle = header.querySelector('#' + (root.querySelector('[data-pyp-modal]').getAttribute('aria-describedby') || ''));
    if (title) title.textContent = config.headline || 'Pick Your Prize';
    if (subtitle) subtitle.textContent = config.subheadline || 'Enter your email, pick your game, and reveal your reward.';

    // Avoid the duplicate title: hide the kicker when it just repeats the headline.
    var kicker = header.querySelector('.pyp-kicker');
    if (kicker && title) {
      var norm = function (s) { return String(s || '').trim().toLowerCase(); };
      if (norm(kicker.textContent) === norm(title.textContent)) {
        kicker.hidden = true;
        kicker.style.display = 'none';
      }
    }
  }

  function bind(root, state) {
    root.querySelector('[data-pyp-teaser]').addEventListener('click', function () {
      openPopup(root, state, 'teaser');
    });
    root.querySelector('[data-pyp-close]').addEventListener('click', function () {
      closePopup(root, state, 'close_button');
    });
    root.querySelector('[data-pyp-overlay]').addEventListener('click', function () {
      closePopup(root, state, 'overlay');
    });
    // Prevent accidental form submission (Enter key); validation happens on game-card click
    root.querySelector('[data-pyp-email-form]').addEventListener('submit', function (event) {
      event.preventDefault();
    });
    // Consent checkbox unlocks game cards
    var consentBox = root.querySelector('[data-pyp-consent]');
    if (consentBox) {
      consentBox.addEventListener('change', function () {
        onConsentChange(root, state);
      });
    }
    document.addEventListener('keydown', function (event) {
      if (!state.opened) return;
      if (event.key === 'Escape') closePopup(root, state, 'escape');
      if (event.key === 'Tab') trapFocus(root, event);
    });
    root.addEventListener('click', function (event) {
      var copy = event.target.closest('[data-pyp-copy]');
      if (copy) copyCode(state, copy);
      var back = event.target.closest('[data-pyp-back]');
      if (back) showView(root, 'picker');
      var shop = event.target.closest('[data-pyp-shop-now]');
      if (shop) track(state.config, 'pyp_shop_now_clicked', eventPayload(state));
    });
  }

  function onConsentChange(root, state) {
    var consentBox = root.querySelector('[data-pyp-consent]');
    var checked = consentBox && consentBox.checked;
    var hint = root.querySelector('[data-pyp-game-hint]');
    var heading = root.querySelector('.pyp-choice-heading');
    root.querySelectorAll('[data-pyp-game]').forEach(function (btn) {
      btn.disabled = !checked;
      btn.setAttribute('aria-disabled', String(!checked));
      btn.classList.toggle('is-locked', !checked);
    });
    if (hint) hint.hidden = checked;
    if (heading) heading.hidden = !checked;
  }

  function renderGames(root, state) {
    var wrap = root.querySelector('[data-pyp-games]');
    var order = String(state.config.gameOrder || 'wheel,scratch,mystery_box')
      .replace(/\bbox\b/g, 'mystery_box')
      .split(',')
      .map(function (item) { return item.trim(); })
      .filter(Boolean);

    wrap.innerHTML = order.map(function (key) {
      var meta = GAME_META[key] || GAME_META.wheel;
      var iconUrl = state.config.cardIcons && state.config.cardIcons[key];
      var icon = iconUrl ? '<img src="' + esc(iconUrl) + '" alt="" loading="lazy">' : ICONS[key];
      var highlighted = key === state.config.defaultGame ? ' is-highlighted' : '';
      // Cards start locked — unlocked when consent checkbox is checked
      return '' +
        '<button class="pyp-game-card' + highlighted + ' is-locked" type="button" data-pyp-game="' + esc(key) + '" aria-label="Choose: ' + esc(meta.title) + '" disabled aria-disabled="true">' +
          '<span class="pyp-game-icon" aria-hidden="true">' + icon + '</span>' +
          '<span><h3>' + esc(meta.title) + '</h3><p>' + esc(meta.subtitle) + '</p></span>' +
          '<span class="pyp-game-cta" aria-hidden="true">Choose This</span>' +
        '</button>';
    }).join('');

    wrap.querySelectorAll('[data-pyp-game]').forEach(function (button) {
      button.addEventListener('click', function () {
        if (button.disabled) return;
        chooseGame(root, state, button.dataset.pypGame);
      });
    });

    // Hide choice heading until consent given
    var heading = root.querySelector('.pyp-choice-heading');
    if (heading) heading.hidden = true;
  }

  function scheduleTrigger(root, state) {
    var config = state.config;
    if (!isEligible(config)) return;
    // Mobile teaser intentionally disabled — popup opens directly on mobile too.
    if (config.triggerType === 'manual') return showTeaser(root);
    if (config.triggerType === 'scroll') {
      window.addEventListener('scroll', onScroll, { passive: true });
      onScroll();
      return;
    }
    if (config.triggerType === 'exit') {
      // On mobile, exit-intent isn't possible — fall back to a short delay open.
      if (!isDesktop()) {
        window.setTimeout(function () { openPopup(root, state, 'mobile_delay'); }, 1500);
        return;
      }
      document.addEventListener('mouseout', function onExit(event) {
        if (event.clientY <= 0) {
          document.removeEventListener('mouseout', onExit);
          openPopup(root, state, 'exit_intent');
        }
      });
      return;
    }
    if (config.triggerType === 'add_to_cart') {
      document.addEventListener('click', function onClick(event) {
        if (event.target.closest('.atc-btn, form[action*="/cart/add"] button[type="submit"]')) {
          document.removeEventListener('click', onClick);
          window.setTimeout(function () { openPopup(root, state, 'add_to_cart'); }, 650);
        }
      });
      return;
    }
    if (config.triggerType === 'cart_value') return watchCartThreshold(root, state);
    window.setTimeout(function () { openPopup(root, state, 'delay'); }, Math.max(0, Number(config.delaySeconds) || 0) * 1000);

    function onScroll() {
      var scrolled = window.scrollY || document.documentElement.scrollTop;
      var max = Math.max(1, document.documentElement.scrollHeight - window.innerHeight);
      if ((scrolled / max) * 100 >= Number(config.scrollPercent || 35)) {
        window.removeEventListener('scroll', onScroll);
        openPopup(root, state, 'scroll');
      }
    }
  }

  function isEligible(config) {
    // Suppress once per browser session — after the user closes/dismisses the popup,
    // they won't see it again on subsequent page loads in the same tab session.
    var key = slug(config.campaignName);
    if (sessionStorage.getItem('pyp_session_' + key)) return false;
    // All other persistent gating (frequency days, conversion, device-win) intentionally disabled.
    return matchesPage(config);
  }

  function matchesPage(config) {
    var path = window.location.pathname;
    if (config.pageRule === 'home') return path === '/';
    if (config.pageRule === 'product') return config.templateName === 'product' || path.indexOf('/products/') !== -1;
    if (config.pageRule === 'collection') return config.templateName === 'collection' || path.indexOf('/collections/') !== -1;
    if (config.pageRule === 'specific') {
      return String(config.specificUrlRules || '').split(',').some(function (rule) {
        return rule.trim() && window.location.href.indexOf(rule.trim()) !== -1;
      });
    }
    return true;
  }

  function openPopup(root, state, trigger) {
    if (state.opened) return;
    state.opened = true;
    state.phase = 'picker';
    state.lastFocus = document.activeElement;
    markSeen(state.config);
    root.querySelector('[data-pyp-teaser]').classList.remove('is-visible');
    root.querySelector('[data-pyp-overlay]').hidden = false;
    root.querySelector('[data-pyp-modal]').hidden = false;
    document.body.style.overflow = 'hidden';
    showView(root, 'picker');
    track(state.config, 'pyp_open', extend(baseEvent(state), { trigger: trigger }));
    track(state.config, 'pyp_picker_viewed', baseEvent(state));
    var input = root.querySelector('[data-pyp-email-form] input[name="email"]');
    if (input) input.focus();
  }

  function closePopup(root, state, reason) {
    if (!state.opened) return;
    state.opened = false;
    state.phase = 'closed';
    root.querySelector('[data-pyp-overlay]').hidden = true;
    root.querySelector('[data-pyp-modal]').hidden = true;
    document.body.style.overflow = '';
    track(state.config, 'pyp_exit', extend(eventPayload(state), { reason: reason, stage: activeView(root) }));
    if (state.lastFocus && state.lastFocus.focus) state.lastFocus.focus();
  }

  async function chooseGame(root, state, gameType) {
    // Validate form inline (email + consent) before proceeding
    var form = root.querySelector('[data-pyp-email-form]');
    var error = root.querySelector('[data-pyp-email-error]');
    var data = new FormData(form);
    var email = String(data.get('email') || '').trim().toLowerCase();
    var firstName = String(data.get('firstName') || '').trim();
    var consent = data.get('consent') === 'on';
    var honeypot = String(data.get('company') || '').trim();

    error.textContent = '';
    if (!isEmail(email)) { setError(error, 'Enter a valid email to unlock your game.'); return; }
    if (isDisposable(email, state.config.disposableDomains)) { setError(error, 'Please use a permanent email address.'); return; }
    if (!consent) { setError(error, 'Consent is required to unlock your game.'); return; }
    if (honeypot) { setError(error, 'We could not unlock the game. Please try again.'); return; }
    if (tooManyAttempts(state.config)) { setError(error, 'Too many attempts. Please try again in a few minutes.'); return; }

    state.lead = { email: email, firstName: firstName, consent: true, consentText: CONSENT_TEXT, consentTimestamp: new Date().toISOString() };
    track(state.config, 'pyp_email_submitted', eventPayload(state));

    state.selectedGame = normalizeGame(gameType);
    state.phase = 'game_loading';
    showGameLoading(root, state);
    track(state.config, 'pyp_game_selection', eventPayload(state));

    try {
      var result = await claimPrize(state);
      if (!result || !result.success || !result.prize) throw new Error((result && result.message) || 'Claim failed');
      state.selectedPrize = normalizePrize(result.prize);
      state.phase = 'game_playing';
      root.classList.toggle('is-grand', isGrand(state.selectedPrize));
      track(state.config, 'pyp_game_started', eventPayload(state));
      runGame(root, state);
    } catch (err) {
      console.error('[Pick Your Prize] Claim failed', err);
      showError(root, state, err.message || 'We could not unlock your prize. Please try again.');
    }
  }

  async function claimPrize(state) {
    var config = state.config;
    // Capture the email (Klaviyo or custom proxy) but NEVER let it block the
    // game — a network/Klaviyo hiccup must not stop the customer from playing.
    if (config.claimEndpoint) {
      try {
        if (config.claimEndpoint.indexOf('a.klaviyo.com/client/subscriptions') !== -1) {
          await subscribeKlaviyo(config, state);
        } else {
          await subscribeProxy(config, state);
        }
      } catch (err) {
        console.warn('[Pick Your Prize] Email capture failed (non-blocking):', err);
      }
    }
    // Always award a weighted-random prize.
    return { success: true, prize: pickWeightedPrize(config) };
  }

  function pickWeightedPrize(config) {
    var prizes = (config.prizes || []).filter(function (p) { return p && p.active !== false; });
    if (!prizes.length) prizes = DEFAULT_PRIZES.map(normalizePrize);
    var totalOdds = prizes.reduce(function (sum, p) { return sum + (parseFloat(p.odds) || 0); }, 0);
    // If no odds are set, treat all prizes as equally likely.
    if (!totalOdds) {
      return prizes[Math.floor(Math.random() * prizes.length)];
    }
    var rand = Math.random() * totalOdds;
    var cumulative = 0;
    for (var i = 0; i < prizes.length; i++) {
      cumulative += (parseFloat(prizes[i].odds) || 0);
      if (rand < cumulative) return prizes[i];
    }
    return prizes[prizes.length - 1];
  }

  function subscribeKlaviyo(config, state) {
    var url = new URL(config.claimEndpoint);
    var listId = url.searchParams.get('list_id');
    var companyId = url.searchParams.get('company_id');

    var body = {
      data: {
        type: 'subscription',
        attributes: {
          profile: {
            data: {
              type: 'profile',
              attributes: {
                email: state.lead.email,
                first_name: state.lead.firstName || ''
              }
            }
          }
        }
      }
    };
    if (listId) {
      body.data.relationships = { list: { data: { type: 'list', id: listId } } };
    }

    return fetch('https://a.klaviyo.com/client/subscriptions/?company_id=' + companyId, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
        'Revision': '2023-12-15'
      },
      body: JSON.stringify(body)
    });
  }

  function subscribeProxy(config, state) {
    return fetch(config.claimEndpoint, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({
        email: state.lead.email,
        firstName: state.lead.firstName,
        consent: state.lead.consent,
        consentText: state.lead.consentText,
        consentTimestamp: state.lead.consentTimestamp,
        campaignId: config.campaignId,
        campaignName: config.campaignName,
        selectedGame: state.selectedGame,
        sourceUrl: window.location.href,
        device: deviceType(),
        sessionId: state.sessionId,
        cartValue: currentCartValue(),
        userAgent: navigator.userAgent,
        company: ''
      })
    });
  }

  function showGameLoading(root, state) {
    var stage = root.querySelector('[data-pyp-game-stage]');
    var meta = GAME_META[state.selectedGame] || GAME_META.wheel;
    showView(root, 'game');
    stage.innerHTML = '' +
      '<div class="pyp-loading-state">' +
        '<div class="pyp-loader" aria-hidden="true"></div>' +
        '<h3>Preparing ' + esc(meta.title) + '</h3>' +
        '<p class="pyp-wheel-label">Securing your one-time reward...</p>' +
      '</div>';
  }

  function runGame(root, state) {
    if (state.selectedGame === 'scratch') return runScratch(root, state);
    if (state.selectedGame === 'mystery_box') return runBox(root, state);
    return runWheel(root, state);
  }

  function runWheel(root, state) {
    var stage = root.querySelector('[data-pyp-game-stage]');
    var prize = state.selectedPrize;
    var big = isGrand(prize);
    var duration = reducedMotion() ? 400 : (big ? 6200 : 4700);
    var labels = visualPrizes(state.config, prize);
    var index = Math.max(0, labels.findIndex(function (item) { return item.id === prize.id || item.name === prize.name; }));
    var segmentAngle = 360 / labels.length;
    var target = 360 * (big ? 8 : 6) + (360 - (index * segmentAngle + segmentAngle / 2));

    stage.innerHTML = '' +
      '<div class="pyp-wheel-wrap">' +
        '<div class="pyp-wheel-rig">' +
          '<div class="pyp-wheel-pointer" aria-hidden="true"></div>' +
          '<div class="pyp-wheel-svg" data-pyp-wheel-svg>' + wheelSlices(labels) + '</div>' +
          '<div class="pyp-wheel-hub" aria-hidden="true">' + wheelHubLogo(state.config) + '</div>' +
        '</div>' +
        '<button class="pyp-stage-btn" type="button" disabled>Spinning...</button>' +
        '<p class="pyp-wheel-label">' + esc((GAME_META.wheel || {}).stageLabel) + '</p>' +
      '</div>';

    var wheel = stage.querySelector('[data-pyp-wheel-svg]');
    wheel.style.setProperty('--pyp-wheel-count', labels.length);
    window.requestAnimationFrame(function () {
      wheel.style.transitionDuration = duration + 'ms';
      wheel.style.transform = 'rotate(' + target + 'deg)';
    });

    window.setTimeout(function () {
      track(state.config, 'pyp_game_completed', eventPayload(state));
      revealPrize(root, state);
    }, duration + 140);
  }

  function runBox(root, state) {
    var stage = root.querySelector('[data-pyp-game-stage]');
    var big = isGrand(state.selectedPrize);
    var duration = reducedMotion() ? 600 : (big ? 4300 : 3000);
    stage.innerHTML = '' +
      '<div class="pyp-box-wrap">' +
        '<div class="pyp-box-stage pyp-box' + (big ? ' is-grand' : '') + '" data-pyp-box>' +
          '<div class="pyp-box-light"></div><div class="pyp-box-prize">' + prizeMedallion(state.selectedPrize) + '</div>' +
          '<div class="pyp-box-lid"><div class="pyp-box-bow"></div></div><div class="pyp-box-base"></div>' +
        '</div>' +
        '<button class="pyp-stage-btn" type="button" disabled>Opening...</button>' +
      '</div>';
    var box = stage.querySelector('[data-pyp-box]');
    box.classList.add('is-shaking');
    window.setTimeout(function () {
      box.classList.remove('is-shaking');
      box.classList.add('is-open');
    }, big ? 1900 : 1300);
    window.setTimeout(function () {
      track(state.config, 'pyp_game_completed', eventPayload(state));
      revealPrize(root, state);
    }, duration);
  }

  function runScratch(root, state) {
    var stage = root.querySelector('[data-pyp-game-stage]');
    var prize = state.selectedPrize;
    var big = isGrand(prize);
    var threshold = 65;
    var drawing = false;
    var done = false;
    var last = null;

    stage.innerHTML = '' +
      '<div class="pyp-scratch-wrap">' +
        '<div class="pyp-scratch-frame"><div class="pyp-scratch-card' + (big ? ' is-grand' : '') + '" data-pyp-scratch>' +
          (state.config.logoUrl ? '<div class="pyp-scratch-watermark" style="background-image:url(' + esc(state.config.logoUrl) + ')"></div>' : '') +
          '<div class="pyp-scratch-prize"><div>' + prizeMedallion(prize) + '</div></div>' +
          '<canvas class="pyp-scratch-canvas" data-pyp-scratch-canvas aria-label="Scratch surface"></canvas>' +
        '</div></div>' +
        '<p class="pyp-wheel-label" data-pyp-scratch-hint>' + (isDesktop() ? 'Hold your mouse down and scratch back and forth.' : 'Hold your finger down and scratch back and forth.') + '</p>' +
        '<div class="pyp-scratch-progress"><span data-pyp-scratch-progress></span></div>' +
        '<div class="pyp-scratch-coin" data-pyp-coin aria-hidden="true"></div>' +
      '</div>';

    var card = stage.querySelector('[data-pyp-scratch]');
    var canvas = stage.querySelector('[data-pyp-scratch-canvas]');
    var ctx = canvas.getContext('2d', { willReadFrequently: true });
    var hint = stage.querySelector('[data-pyp-scratch-hint]');
    var bar = stage.querySelector('[data-pyp-scratch-progress]');
    var coin = stage.querySelector('[data-pyp-coin]');

    setupCanvas();
    window.addEventListener('resize', setupCanvas);
    canvas.addEventListener('pointerdown', startScratch);
    canvas.addEventListener('pointermove', scratch);
    canvas.addEventListener('pointerup', stopScratch);
    canvas.addEventListener('pointercancel', stopScratch);
    canvas.addEventListener('pointerleave', stopScratch);
    canvas.addEventListener('touchmove', preventTouchScroll, { passive: false });

    function setupCanvas() {
      if (done) return;
      var rect = card.getBoundingClientRect();
      var ratio = window.devicePixelRatio || 1;
      canvas.width = Math.max(1, Math.round(rect.width * ratio));
      canvas.height = Math.max(1, Math.round(rect.height * ratio));
      canvas.style.width = rect.width + 'px';
      canvas.style.height = rect.height + 'px';
      ctx.setTransform(ratio, 0, 0, ratio, 0, 0);
      var cover = ctx.createLinearGradient(0, 0, rect.width, rect.height);
      cover.addColorStop(0, '#fff4d2');
      cover.addColorStop(0.24, '#d4a850');
      cover.addColorStop(0.5, '#8b6520');
      cover.addColorStop(0.75, '#e8c878');
      cover.addColorStop(1, '#fff4d2');
      ctx.globalCompositeOperation = 'source-over';
      ctx.fillStyle = cover;
      ctx.fillRect(0, 0, rect.width, rect.height);
      ctx.fillStyle = 'rgba(80,55,15,0.42)';
      ctx.font = '700 34px Cinzel, serif';
      ctx.textAlign = 'center';
      ctx.fillText('SCRATCH', rect.width / 2, rect.height / 2 - 8);
      ctx.font = '600 13px Cinzel, serif';
      ctx.fillText('TO REVEAL', rect.width / 2, rect.height / 2 + 22);
    }

    function startScratch(event) {
      drawing = true;
      last = null;
      if (canvas.setPointerCapture) canvas.setPointerCapture(event.pointerId);
      scratch(event);
    }

    function stopScratch() {
      drawing = false;
      last = null;
      if (coin) coin.style.display = 'none';
    }

    function scratch(event) {
      if (!drawing || done) return;
      event.preventDefault();
      var point = canvasPoint(canvas, event);
      if (coin && isDesktop()) {
        coin.style.display = 'block';
        coin.style.left = event.clientX - 17 + 'px';
        coin.style.top = event.clientY - 17 + 'px';
      }
      ctx.save();
      ctx.globalCompositeOperation = 'destination-out';
      ctx.lineWidth = Math.max(34, canvas.getBoundingClientRect().width * 0.14);
      ctx.lineCap = 'round';
      ctx.lineJoin = 'round';
      ctx.beginPath();
      if (last) {
        ctx.moveTo(last.x, last.y);
        ctx.lineTo(point.x, point.y);
      } else {
        ctx.arc(point.x, point.y, ctx.lineWidth / 2, 0, Math.PI * 2);
      }
      ctx.stroke();
      ctx.fill();
      ctx.restore();
      last = point;
      var progress = scratchProgress(ctx, canvas);
      if (bar) bar.style.setProperty('--pyp-progress', progress + '%');
      if (hint && progress < threshold) hint.textContent = Math.max(0, threshold - progress) + '% more gold foil to reveal your prize.';
      if (progress >= threshold) finishScratch();
    }

    function finishScratch() {
      if (done) return;
      done = true;
      drawing = false;
      canvas.removeEventListener('touchmove', preventTouchScroll);
      window.removeEventListener('resize', setupCanvas);
      canvas.style.opacity = '0';
      canvas.style.pointerEvents = 'none';
      if (bar) bar.style.setProperty('--pyp-progress', '100%');
      if (hint) hint.textContent = 'Prize revealed';
      window.setTimeout(function () {
        track(state.config, 'pyp_game_completed', eventPayload(state));
        revealPrize(root, state);
      }, reducedMotion() ? 250 : (big ? 1500 : 900));
    }
  }

  function revealPrize(root, state) {
    var prize = state.selectedPrize;
    var big = isGrand(prize);
    state.phase = 'revealed';
    showView(root, 'revealed');
    markClaimed(state);
    track(state.config, 'pyp_prize_won', eventPayload(state));
    root.querySelector('[data-pyp-revealed]').innerHTML = revealHtml(state);
    startCountdown(root);
    burstConfetti(root, big ? 96 : 26);
    var shop = root.querySelector('[data-pyp-shop-now]');
    if (shop) shop.focus();
  }

  function revealHtml(state) {
    var prize = state.selectedPrize;
    var title = isGrand(prize) ? 'Grand Prize Unlocked' : 'You unlocked ' + (prize.name || 'your reward');
    var img = prize.imageUrl || prize.image;
    return '' +
      '<div class="pyp-reveal-card' + (isGrand(prize) ? ' is-grand' : '') + '">' +
        '<div style="position:relative">' + prizeMedallion(prize) + '</div>' +
        (img ? '<img class="pyp-prize-image" src="' + esc(img) + '" alt="" loading="lazy">' : '') +
        '<div class="pyp-ribbon">' + esc(title) + '</div>' +
        '<div class="pyp-prize-card"><p>Your reward is locked in — it applies automatically at checkout.</p><p class="pyp-countdown" data-pyp-countdown>Your reward expires in 09:59</p></div>' +
        prizeCode(prize) +
        '<a class="pyp-shop-btn" data-pyp-shop-now href="' + esc(prize.shopUrl || shopUrl(prize, state.config)) + '">Shop Now — Discount Applied</a>' +
      '</div>';
  }

  function prizeCode(prize) {
    var code = prize.discountCode || prize.discount_code || '';
    if (!code) return '';
    return '' +
      '<div class="pyp-code pyp-code--auto">' +
        '<div><span>Discount Code</span><strong>' + esc(code) + '</strong></div>' +
        '<span class="pyp-code-auto-tag">Auto-applied at checkout</span>' +
      '</div>';
  }

  function showError(root, state, message) {
    state.phase = 'error';
    showView(root, 'error');
    root.querySelector('[data-pyp-error-state]').innerHTML = '' +
      '<div class="pyp-prize-card"><h3>Something went wrong</h3><p>' + esc(message) + '</p></div>' +
      '<button class="pyp-claim-btn" type="button" data-pyp-back>Try Again</button>';
    track(state.config, 'pyp_claim_error', extend(eventPayload(state), { message: message }));
  }

  function showView(root, name) {
    root.querySelectorAll('[data-pyp-view]').forEach(function (view) {
      view.classList.toggle('is-active', view.dataset.pypView === name);
    });
    root.querySelector('[data-pyp-modal]').dataset.pypState = name;
    var shell = root.querySelector('[data-pyp-shell]');
    if (shell) shell.scrollTop = 0;
  }

  function showTeaser(root) {
    root.querySelector('[data-pyp-teaser]').classList.add('is-visible');
  }

  function markSeen(config) {
    var key = slug(config.campaignName);
    sessionStorage.setItem('pyp_session_' + key, '1');
    localStorage.setItem('pyp_seen_' + key, String(Date.now()));
    localStorage.setItem('pyp_seen_any', String(Date.now()));
  }

  function markClaimed(state) {
    var key = slug(state.config.campaignName);
    localStorage.setItem('pyp_converted_' + key, '1');
    localStorage.setItem('pyp_device_win_' + key, JSON.stringify({
      email: state.lead && state.lead.email,
      game: state.selectedGame,
      prizeName: state.selectedPrize && state.selectedPrize.name,
      claimedAt: new Date().toISOString()
    }));
  }

  function track(config, eventName, detail) {
    var payload = extend({ event: eventName, campaign_name: config.campaignName || 'Pick Your Prize' }, detail || {});
    window.dispatchEvent(new CustomEvent(eventName, { detail: payload }));
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(payload);
  }

  function baseEvent(state) {
    return {
      campaign_id: state.config.campaignId,
      source_url: window.location.href,
      device: deviceType(),
      session_id: state.sessionId
    };
  }

  function eventPayload(state) {
    var prize = state.selectedPrize || {};
    return extend(baseEvent(state), {
      email: state.lead && state.lead.email,
      selected_game: state.selectedGame,
      prize_id: prize.id,
      prize_name: prize.name,
      prize_type: prize.type,
      is_grand_prize: isGrand(prize)
    });
  }

  function copyCode(state, button) {
    var code = button.dataset.pypCopy || '';
    if (!code) return;
    var done = function () {
      button.textContent = 'Copied!';
      track(state.config, 'pyp_code_copied', eventPayload(state));
      window.setTimeout(function () { button.textContent = 'Copy Code'; }, 1800);
    };
    var fallback = function () {
      try {
        var ta = document.createElement('textarea');
        ta.value = code;
        ta.setAttribute('readonly', '');
        ta.style.position = 'fixed';
        ta.style.top = '0';
        ta.style.left = '0';
        ta.style.opacity = '0';
        document.body.appendChild(ta);
        ta.focus();
        ta.select();
        ta.setSelectionRange(0, code.length);
        document.execCommand('copy');
        document.body.removeChild(ta);
        done();
      } catch (err) {
        button.textContent = code;
      }
    };
    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(code).then(done, fallback);
    } else {
      fallback();
    }
  }

  function startCountdown(root) {
    var target = Date.now() + 10 * 60 * 1000;
    var el = root.querySelector('[data-pyp-countdown]');
    if (!el) return;
    window.clearInterval(root._pypCountdown);
    root._pypCountdown = window.setInterval(function () {
      var remain = Math.max(0, target - Date.now());
      var mins = String(Math.floor(remain / 60000)).padStart(2, '0');
      var secs = String(Math.floor((remain % 60000) / 1000)).padStart(2, '0');
      el.textContent = 'Your reward expires in ' + mins + ':' + secs;
      if (!remain) window.clearInterval(root._pypCountdown);
    }, 1000);
  }

  function burstConfetti(root, count) {
    var holder = root.querySelector('[data-pyp-confetti]');
    if (!holder || reducedMotion()) return;
    holder.innerHTML = '';
    for (var i = 0; i < count; i += 1) {
      var piece = document.createElement('span');
      piece.style.left = ((i * 37) % 100) + '%';
      piece.style.setProperty('--pyp-x', (((i * 29) % 160) - 80) + 'px');
      piece.style.setProperty('--pyp-r', ((i * 41) % 360) + 'deg');
      piece.style.animationDelay = ((i % 9) * 0.035) + 's';
      holder.appendChild(piece);
    }
    window.setTimeout(function () { holder.innerHTML = ''; }, 2200);
  }

  function wheelSlices(prizes) {
    return prizes.map(function (prize, index) {
      return '<span class="pyp-wheel-slice pyp-wheel-slice--' + (index % 2 ? 'dark' : 'red') + '" style="--i:' + index + ';--n:' + prizes.length + '"><b>' + esc(prize.shortLabel || prize.name || 'Prize') + '</b></span>';
    }).join('');
  }

  function wheelHubLogo(config) {
    if (!config.logoUrl) {
      return '<div class="pyp-wheel-hub-logo" style="display:flex;align-items:center;justify-content:center;background:#08100a;font-family:var(--pyp-display);font-size:11px;font-weight:700;letter-spacing:0.14em;color:#d4a850;text-align:center;padding:8px;line-height:1.1;">PICK<br>YOUR<br>PRIZE</div>';
    }
    return '<img class="pyp-wheel-hub-logo" src="' + esc(config.logoUrl) + '" alt="" loading="lazy" onerror="this.style.display=\'none\'">';
  }

  function prizeMedallion(prize) {
    return '' +
      '<div class="pyp-medallion">' +
        '<div class="pyp-medallion-ring"><div class="pyp-medallion-inner">' +
          '<div class="pyp-medallion-value">' + esc(prize.shortLabel || prizeShort(prize)) + '</div>' +
          '<div class="pyp-medallion-name">' + esc(prize.name || 'Prize') + '</div>' +
        '</div></div>' +
      '</div>';
  }

  function visualPrizes(config, prize) {
    var list = config.prizes && config.prizes.length ? config.prizes.slice(0) : [];
    if (!list.some(function (item) { return item.id === prize.id || item.name === prize.name; })) list.push(prize);
    while (list.length < 6) list.push({ name: 'Reward', shortLabel: 'WIN' });
    return list;
  }

  function normalizePrize(prize) {
    prize = prize || {};
    return {
      id: prize.id || '',
      name: prize.name || 'Prize',
      type: prize.type || 'percentage',
      shortLabel: prize.shortLabel || prize.short_label || prizeShort(prize),
      image: prize.image || null,
      imageUrl: prize.imageUrl || prize.image_url || prize.image || null,
      discountCode: prize.discountCode || prize.discount_code || '',
      shopUrl: prize.shopUrl || prize.shop_url || '',
      odds: parseFloat(prize.odds) || 0,
      active: prize.active !== false,
      grand: Boolean(prize.grand || prize.isGrandPrize || prize.is_grand_prize || prize.grand_prize)
    };
  }

  function prizeShort(prize) {
    var name = String(prize.name || '');
    var pct = name.match(/\d+\s*%/);
    if (isGrand(prize)) return 'GRAND';
    if (pct) return pct[0].replace(/\s+/g, '');
    if (prize.type === 'free_shipping') return 'SHIP';
    if (prize.type === 'free_gift') return 'GIFT';
    if (prize.type === 'bundle') return 'BUNDLE';
    return 'WIN';
  }

  function shopUrl(prize, config) {
    var code = prize.discountCode || prize.discount_code || '';
    var redirect = config.redirectPath || '/';
    if (!redirect || redirect === '/collections/all') redirect = '/';
    if (!code) return redirect;
    return '/discount/' + encodeURIComponent(code) + '?redirect=' + encodeURIComponent(redirect);
  }

  function canvasPoint(canvas, event) {
    var rect = canvas.getBoundingClientRect();
    return {
      x: Math.max(0, Math.min(rect.width, event.clientX - rect.left)),
      y: Math.max(0, Math.min(rect.height, event.clientY - rect.top))
    };
  }

  function scratchProgress(ctx, canvas) {
    var image = ctx.getImageData(0, 0, canvas.width, canvas.height).data;
    var cleared = 0;
    var sampled = 0;
    var stride = 18;
    for (var y = 0; y < canvas.height; y += stride) {
      for (var x = 0; x < canvas.width; x += stride) {
        sampled += 1;
        if (image[((y * canvas.width + x) * 4) + 3] < 250) cleared += 1;
      }
    }
    return Math.round((cleared / Math.max(1, sampled)) * 100);
  }

  function trapFocus(root, event) {
    var focusable = Array.prototype.slice.call(root.querySelectorAll('button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])')).filter(function (el) {
      return !el.disabled && el.offsetParent !== null;
    });
    if (!focusable.length) return;
    var first = focusable[0];
    var last = focusable[focusable.length - 1];
    if (event.shiftKey && document.activeElement === first) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault();
      first.focus();
    }
  }

  function watchCartThreshold(root, state) {
    fetch('/cart.js').then(function (res) { return res.json(); }).then(function (cart) {
      if (Number(cart.total_price || 0) >= Number(state.config.cartThreshold || 0)) openPopup(root, state, 'cart_value');
      else showTeaser(root);
    }).catch(function () { showTeaser(root); });
  }

  function tooManyAttempts(config) {
    var key = 'pyp_attempts_' + slug(config.campaignName);
    var now = Date.now();
    var attempts = JSON.parse(localStorage.getItem(key) || '[]').filter(function (time) { return now - time < 300000; });
    attempts.push(now);
    localStorage.setItem(key, JSON.stringify(attempts));
    return attempts.length > 25;
  }

  function getSessionId(config) {
    var key = 'pyp_session_id_' + slug(config.campaignName);
    var existing = sessionStorage.getItem(key);
    if (existing) return existing;
    var id = 'pyps-' + Date.now().toString(36) + '-' + (window.crypto && crypto.randomUUID ? crypto.randomUUID() : String(Date.now()));
    sessionStorage.setItem(key, id);
    return id;
  }

  function currentCartValue() {
    return window.PickYourPrizeCartValue || null;
  }

  function activeView(root) {
    var active = root.querySelector('[data-pyp-view].is-active');
    return active ? active.dataset.pypView : 'closed';
  }

  function normalizeGame(game) {
    var map = {
      box: 'mystery_box',
      mystery_box: 'mystery_box',
      wheel: 'wheel',
      spin: 'wheel',
      scratch: 'scratch',
      scratch_card: 'scratch'
    };
    var key = String(game || '').toLowerCase().trim();
    return map[key] || key;
  }

  function isGrand(prize) {
    return Boolean(prize && (prize.grand || prize.isGrandPrize || prize.is_grand_prize || prize.type === 'grand_prize'));
  }

  function isEmail(email) {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
  }

  function isDisposable(email, domains) {
    var domain = String(email).split('@')[1] || '';
    return String(domains || '').toLowerCase().split(',').map(function (item) { return item.trim(); }).indexOf(domain) !== -1;
  }

  function setError(el, message) {
    el.textContent = message;
  }

  function preventTouchScroll(event) {
    event.preventDefault();
  }

  function deviceType() {
    if (window.matchMedia('(pointer: coarse)').matches) return 'mobile';
    return window.innerWidth < 768 ? 'mobile' : 'desktop';
  }

  function isDesktop() {
    return window.matchMedia('(min-width: 768px) and (pointer: fine)').matches;
  }

  function reducedMotion() {
    return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  function slug(value) {
    return String(value || 'pick-your-prize').toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/(^-|-$)/g, '') || 'pick-your-prize';
  }

  function extend(target, source) {
    target = target || {};
    Object.keys(source || {}).forEach(function (key) {
      if (source[key] !== undefined && source[key] !== null) target[key] = source[key];
    });
    return target;
  }

  function esc(value) {
    return String(value == null ? '' : value)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#039;');
  }
})();
